import API from './base';

class ReservationsAPI extends API {
  list() {
    return this.get('/api/web/v1/student/reservations');
  }

  cancel(id) {
    return this.delete(`/api/web/v1/student/reservations/${id}`);
  }

  updateLaPosteReservation(id) {
    return this.post('/api/web/v1/la_poste/new_reservations/', { id });
  }

  getExamResultDocument(id) {
    return window.location.assign(
      `/api/web/v1/student/reservations/${id}/exam_result_document`,
    );
  }

  getConvocationDocument(id) {
    return window.location.assign(
      `/api/web/v1/student/reservations/${id}/convocation_document`,
    );
  }

  getBillDocument(id) {
    return window.location.assign(
      `/api/web/v1/student/reservations/${id}/bill_document`,
    );
  }
}

export default new ReservationsAPI();
